/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftControllerDtoNftGenerateCreateRequest model module.
 * @module model/NftControllerDtoNftGenerateCreateRequest
 * @version 1.0
 */
class NftControllerDtoNftGenerateCreateRequest {
    /**
     * Constructs a new <code>NftControllerDtoNftGenerateCreateRequest</code>.
     * @alias module:model/NftControllerDtoNftGenerateCreateRequest
     */
    constructor() { 
        
        NftControllerDtoNftGenerateCreateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftControllerDtoNftGenerateCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftControllerDtoNftGenerateCreateRequest} obj Optional instance to populate.
     * @return {module:model/NftControllerDtoNftGenerateCreateRequest} The populated <code>NftControllerDtoNftGenerateCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftControllerDtoNftGenerateCreateRequest();

            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = ApiClient.convertToType(data['nftSeal'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftControllerDtoNftGenerateCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftControllerDtoNftGenerateCreateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {String} title
 */
NftControllerDtoNftGenerateCreateRequest.prototype['title'] = undefined;

/**
 * @member {Number} accountNo
 */
NftControllerDtoNftGenerateCreateRequest.prototype['accountNo'] = undefined;

/**
 * @member {Number} nftSeal
 */
NftControllerDtoNftGenerateCreateRequest.prototype['nftSeal'] = undefined;






export default NftControllerDtoNftGenerateCreateRequest;

